import styled from "@emotion/styled";

export const Wrapper = styled.section`
  --Form-row-gap: 40px;
  display: flex;
  flex-direction: column;
  row-gap: var(--Form-row-gap);
`;
